module.exports = require('./src/ScrollLock');



//////////////////
// WEBPACK FOOTER
// ./~/react-scrolllock/index.js
// module id = 628
// module chunks = 0